import { React, Styled } from '@common/3rd';
import { DeskComponentRegistry, Widget } from '@component';

export type DeskTopStepsProps = {
	steps: string[];
	activeIndex: number;
};
export type DeskTopStepsComponents = {
	Box: any;
};
class DeskTopSteps<P extends DeskTopStepsProps,
	S extends { boxWidth: number },
 	C extends DeskTopStepsComponents> extends Widget<P, S, C> {
	boxRef: React.RefObject<HTMLDivElement> = React.createRef();
	componentDidMount() {
		super.componentDidMount();
		this.detectButtonCount();
		this.setState({
			boxWidth: document.querySelector('[data-widget=desk-top-steps]')?.clientWidth || 0
		});
	}

	componentDidUpdate(prevProps: any, prevState?: any, prevContext?: any) {
		super.componentDidUpdate(prevProps, prevState, prevContext);
        this.detectButtonCount();
        const steps = document.querySelector('[data-widget=desk-top-steps]');
		if (steps && steps.clientWidth && prevState.boxWidth !== steps.clientWidth) {
			this.setState({
				boxWidth: steps.clientWidth
			});
		}
	}

	protected detectButtonCount(): void {
		const box = this.boxRef.current;
		if (box != null) {
			box.style.setProperty('--data-children-count', `${box.childElementCount}`);
		}
	}
	protected initComponents(): C {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'desk-top-steps'
			})<{boxWidth: number}>`
				display: grid;
				position: relative;
				grid-template-columns: ${new Array(this.getStepCount()).fill('1fr').join(' ')};
				padding-top: 30px;
				padding-bottom: 30px;

				// &:after {
				// 	content: '';
				// 	z-index: -1;
				// 	display: block;
				// 	position: absolute;
				// 	width: 200%;
				// 	border-radius: 100%;
				// 	height: 300%;
				// 	background-color: ${props => props.theme.COLOR_PRIMARY};
				// 	opacity: 0.05;
				// 	left: -50%;
				// 	bottom: 10px;
				// }

				${(props: any) => {
					let cellWidth = '100vw';
					if (this.getStepCount() >= 1) {
						let scale = (props.boxWidth) / window.innerWidth;
						cellWidth = `${Math.round(scale * 10000 / (this.getStepCount())) / 100}vw`;
					}
					return `
						> div {
							position: relative;
							text-align: center;
							> span {
								color: ${props.theme.COLOR_PRIMARY};
								font-weight: ${props.theme.FONT_WEIGHT_BOLD};
								opacity: 0.5;
							}
							> span:first-child {
								display: inline-block;
								position: relative;
								border-radius: 50%;
								height: 36px;
								line-height: 32px;
								width: 36px;
								font-size: 20px;
								border-width: ${props.theme.BORDER_WIDTH * 2}px;
								border-color: ${props.theme.COLOR_PRIMARY};
								background-color: ${props.theme.COLOR_PRIMARY};
								border-style: solid;
								color: white;
							}
							> span:last-child {
								display: block;
								text-align: center;
							}
							&:nth-child(-n + ${this.getActiveStepIndex()}) {
								> span:first-child:after {
									content: '';
									display: block;
									position: absolute;
									background-color: ${props.theme.COLOR_PRIMARY};
									height: 2px;
									width: calc(${cellWidth} - 36px);
									top: calc(50% - 1px);
									left: calc(100% + 2px);
								}
							}
							&:nth-child(${this.getActiveStepIndex() + 1}):not(:last-child) {
								> span:first-child:after {
									content: '';
									display: block;
									position: absolute;
									background-color: ${props.theme.COLOR_PRIMARY};
									height: 2px;
									width: calc((${cellWidth} - 36px) / 2);
									top: calc(50% - 1px);
									left: calc(100% + 2px);
								}
							}
							&:nth-child(-n + ${this.getActiveStepIndex() + 1}) {
								> span {
									opacity: 1;
								}
							}
							&:not(:first-child) > span:first-child:before {
								content: '';
								display: block;
								position: absolute;
								background-color: ${props.theme.COLOR_PRIMARY};
								height: 2px;
								width: calc(${cellWidth} - 36px);
								top: calc(50% - 1px);
								right: calc(100% + 2px);
							}
						}
						`
				}
				}
				${props => this.renderCSS(props.theme)}
			`
		} as C;
	}
	render() {
		const { Box } = this.getComponents();
		return (
			<Box ref={this.boxRef} boxWidth={this.state.boxWidth}>
				{this.getSteps().map((step: string, index: number) => {
					return (
						<div key={step}>
							<span>{index + 1}</span>
							<span>{step}</span>
						</div>
					);
				})}
			</Box>
		);
	}
	protected getSteps(): string[] {
		return this.props.steps;
	}
	protected getStepCount(): number {
		return this.getSteps().length;
	}
	protected getActiveStepIndex(): number {
		return this.props.activeIndex;
	}
}

DeskComponentRegistry.register({
	topSteps: DeskTopSteps
});

export { DeskTopSteps };
